import React from 'react'
import { GridOverlay } from '@mui/x-data-grid'

export default function NoRowsOverlay() {
  return <GridOverlay>No data found</GridOverlay>
}
